import { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
const AddcaseStudy = () => {
  const [file, setFile] = useState(null);
  const [img, setImg] = useState();
  const [like, setLike] = useState();
  const [role, setRole] = useState();
  const [goal, setGoal] = useState();
  const [caseProcess, setCaseProcess] = useState();
  const [research, setResearch] = useState();
  const [successMes, setSuccessMes] = useState('')
  const convertbase64 = async (file) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      setImg(fileReader.result);
    };
    fileReader.onerror = (error) => {
      console.log(error);
    };
  };
  const handleUpload = async (e) => {
    setFile(e.target.files[0]);
    const file = e.target.files[0];
    await convertbase64(file);
  };

  const handleStudy = async () => {
    try {
      const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/case`,{
        like,
        goal,
        caseProcess,
        research,
        role,
        image:img
      })
      setFile(null)
      setLike('')
      setGoal('')
      setCaseProcess('')
      setResearch('')
      setRole('')
      setImg('')
      console.log(data);
      setSuccessMes(data)
    } catch (error) {
      console.log(error.response.data.error);
    }
  };
  return (
    <div className="mt-20 sm:ml-5 relative w-full">
      <div className="flex lg:flex-row flex-col ">
        <div className="lg:block flex flex-col lg:justify-start justify-center lg:items-start items-center">
          <input
            className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[370px] w-[300px] my-3"
            type="number"
            placeholder="Like"
            value={like}
            onChange={(e) => setLike(e.target.value)}
          />
          <textarea
            name="process"
            id=""
            rows="5"
            placeholder="Process"
            value={caseProcess}
            className="border  focus:border-[#FE4904] sm:w-[370px] w-[300px] outline-none rounded-lg px-4 py-6 resize-none text-lg border-black-500"
            onChange={(e) => setCaseProcess(e.target.value)}
          />
        </div>
        <div className="lg:block flex flex-col lg:justify-start justify-center lg:items-start items-center">
          <input
            className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[370px] w-[300px] my-3"
            type="text"
            placeholder="Role"
            value={(role)}
            onChange={(e) => setRole(e.target.value)}
          />
          <textarea
            name="research"
            id=""
            rows="5"
            placeholder="Research"
            value={research}
            className="border  focus:border-[#FE4904] sm:w-[370px] w-[300px] outline-none rounded-lg px-4 py-6 resize-none text-lg border-black-500"
            onChange={(e) => setResearch(e.target.value)}
          />
        </div>
      </div>
      <div className="flex flex-col lg:items-start items-center lg:justify-start justify-center">
        <input
          className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[370px] w-[300px] my-3"
          type="text"
          value={goal}
          placeholder="Goal"
          onChange={(e) => setGoal(e.target.value)}
        />
        <div
          id="dropzone"
          className="border border-dashed sm:w-[370px] w-[300px] h-[200px] relative flex justify-center items-center"
        >
          {file ? (
            <div className="relative w-full">
              <img
                className="sm:w-[370px] w-[300px] h-[200px] object-contain"
                src={URL.createObjectURL(file)}
                alt=""
              />
              <AiFillCloseCircle
                onClick={() => setFile(null)}
                className="absolute top-2 right-2 text-2xl text-gray-700"
              />
            </div>
          ) : (
            <span className="">Select picture to see the preview</span>
          )}
        </div>
        <input type="file" id="fileInput" onChange={handleUpload} hidden />
        <button className="bg-gradient-to-r mt-3 w-[150px] from-[#FE4904] to-[#F7164C] flex items-center text-white rounded-lg py-2 px-4 ">
          <label htmlFor="fileInput" className="w-[150px] cursor-pointer">
            <AiFillFileAdd className="w-[25px] mr-2 inline-flex h-[25px] text-center object-cover ml-2 cursor-pointer" />
            <span>Add Pic</span>
          </label>
        </button>
      </div>
      <div className="w-full flex items-center justify-center">
        <button
          onClick={handleStudy}
          className="border border-[#FE4904] px-2 py-2 rounded-lg mt-4"
        >
          Add case Study
        </button>
      </div>
    </div>
  );
};
export default AddcaseStudy;
